import axios from 'axios';

const CHAT_CLOSED_DETAIL = 'Контакты уже переданы, переписка завершена';
export const CHAT_CLOSED_MESSAGE = 'Чат закрыт: контакты уже обменяны, новые сообщения недоступны.';
export const CHAT_MODERATION_BLOCKED_MESSAGE =
  'Чат заблокирован модерацией, отправка сообщений недоступна.';

export function formatChatMessagingError(error: unknown): string | null {
  if (!axios.isAxiosError(error)) {
    return null;
  }
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string' && detail.includes(CHAT_CLOSED_DETAIL)) {
    return CHAT_CLOSED_MESSAGE;
  }
  if (typeof detail === 'string' && detail.toLowerCase().includes('модерац')) {
    return CHAT_MODERATION_BLOCKED_MESSAGE;
  }
  if (typeof detail === 'string' && detail.toLowerCase().includes('заблокирован')) {
    return detail;
  }
  return null;
}
